import { publicUrl } from '../routing/basePath'

export function PresenterLockup() {
  return (
    <img
      alt="Rockstar Energy Drink presents"
      className="presenter-lockup"
      data-presenter-lockup
      decoding="sync"
      fetchPriority="high"
      height="48"
      src={publicUrl('assets/rockstar-presenter-lockup.png')}
      width="112"
    />
  )
}
